module.exports = __webpack_public_path__ + "img/helperInfo.9dd38a8b.png";